/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.SummarizationRpc
 */
import * as References from './SummarizationRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.SummarizationRpc#summarizeVideo
 */
export const SUMMARIZE_VIDEO_QUERY_FIELD_NAME = 'com_hubspot_academy_gen_ai_skills_rpc_SummarizationRpc_summarizeVideo';
export const SUMMARIZE_VIDEO_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SUMMARIZE_VIDEO_QUERY_FIELD_NAME,
  args: ['videoId', 'contentPortalId', 'skipCache', 'outputLanguage', 'numberOfQuestions', 'difficulty'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.summarizeVideoRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.SummarizationRpc#asyncBulkGenerateVideoSummary
 */
export const ASYNC_BULK_GENERATE_VIDEO_SUMMARY_MUTATION_FIELD_NAME = 'com_hubspot_academy_gen_ai_skills_rpc_SummarizationRpc_asyncBulkGenerateVideoSummary';
export const ASYNC_BULK_GENERATE_VIDEO_SUMMARY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ASYNC_BULK_GENERATE_VIDEO_SUMMARY_MUTATION_FIELD_NAME,
  args: ['videos'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.asyncBulkGenerateVideoSummaryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.SummarizationRpc#asyncBulkGetVideoSummary
 */
export const ASYNC_BULK_GET_VIDEO_SUMMARY_QUERY_FIELD_NAME = 'com_hubspot_academy_gen_ai_skills_rpc_SummarizationRpc_asyncBulkGetVideoSummary';
export const ASYNC_BULK_GET_VIDEO_SUMMARY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: ASYNC_BULK_GET_VIDEO_SUMMARY_QUERY_FIELD_NAME,
  args: ['taskIds'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.asyncBulkGetVideoSummaryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});